module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [(_vm.mostrarConfirmacionEliminar) ? _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      },
      "do": function($event) {
        return _vm.eliminar()
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.confirmacionEliminarTitulo))]), _c('span', {
    attrs: {
      "slot": "information"
    },
    slot: "information"
  }, [_vm._v(_vm._s(_vm.confirmacionEliminarDescripcion))]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSendingEliminar) ? [_vm._v("Eliminando..."), _c('span', {
    staticClass: "icon is-small ml-5"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])] : [_vm._v("Eliminar")]], 2)])], 1)], 1) : _vm._e(), _c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_vm._m(0), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret"
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "columns is-multiline display-flex"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Estado")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.estado),
      expression: "filtros.estado"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "estado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltro]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Todos")]), _c('option', {
    domProps: {
      "value": '1'
    }
  }, [_vm._v("Terminado")]), _c('option', {
    domProps: {
      "value": '2'
    }
  }, [_vm._v("Anulado")]), _c('option', {
    domProps: {
      "value": '0'
    }
  }, [_vm._v("Pendiente")])])])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro display-flex"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Creadas por mi")])]), _c('div', {
    staticClass: "display-flex mt-5 mb-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.creadoPorMi),
      expression: "filtros.creadoPorMi"
    }],
    staticClass: "checkbox flex-1",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.filtros.creadoPorMi) ? _vm._i(_vm.filtros.creadoPorMi, null) > -1 : (_vm.filtros.creadoPorMi)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.filtros.creadoPorMi,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "creadoPorMi", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "creadoPorMi", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "creadoPorMi", $$c)
        }
      }, _vm.changeFiltro]
    }
  })])])])])]) : _vm._e(), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.fetch()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])])])])], 1), _c('div', {
    key: "body",
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [_c('transition-group', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "contenedor-data",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2",
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "is-desktop",
    staticClass: "is-desktop"
  }, [(_vm.lista.length !== 0) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Título")]), _c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("Asistentes")]), _c('th', [_vm._v("Fecha")]), _c('th')]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: 'desktop-table-row-' + index,
      staticClass: "row-table"
    }, [_c('td', [_c('span', {
      staticClass: "hint--top inline",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_vm._v(_vm._s(o.titulo) + " ")])]), _c('td', [_c('span', [_vm._v(_vm._s(o.tipo === 'capacitacion' ? 'Capacitación' : 'Reunión') + " " + _vm._s(o.modalidad))])]), _c('td', [_c('span', [_vm._v(_vm._s(o.numeroAsistentes))])]), _c('td', [_c('span', [_vm._v(_vm._s(o.fecha) + " " + _vm._s(o.horaDesde) + " - " + _vm._s(o.horaHasta))])]), _c('td', [_c('div', {
      staticClass: "contenedor-acciones display-flex aic"
    }, [(o.codigoCreador === _vm.codigo) ? [_c('button', {
      staticClass: "button is-small m-2",
      on: {
        "click": function($event) {
          return _vm.redirigir(o.id)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]), (o.estado !== 1) ? _c('button', {
      staticClass: "button is-small m-2 is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]), _c('span', [_vm._v("Eliminar")])]) : _vm._e()] : _vm._e(), _c('button', {
      staticClass: "button is-small m-2",
      on: {
        "click": function($event) {
          return _vm.verDetalle(o.id)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Ver")])])], 2)])])
  }), 0)], 1) : _vm._e()]), _c('div', {
    key: "is-mobile",
    staticClass: "is-mobile"
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: 'mobile-table-row-' + index,
      staticClass: "box"
    }, [_c('div', {
      staticClass: "status"
    }, [_c('span', [_vm._v("ASISTENTES: " + _vm._s(o.numeroAsistentes))])]), _c('div', {
      staticClass: "perfil"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v(_vm._s(o.tipo === 'capacitacion' ? 'Capacitación' : 'Reunión') + " " + _vm._s(o.modalidad))])]), _c('div', {
      staticClass: "descripcion-tipo hint--top",
      attrs: {
        "aria-label": 'ID relacionado: ' + o.idRelacionado
      }
    }), _c('div', {
      staticClass: "motivo hint--bottom",
      attrs: {
        "aria-label": 'Log: ' + o.id
      }
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v(_vm._s(o.titulo))]), _c('div', {
      staticClass: "has-text-lef datos-auditoria"
    }), _c('div', {
      staticClass: "fecha"
    }, [_vm._v(_vm._s(o.fecha) + " " + _vm._s(o.horaDesde) + " " + _vm._s(o.horaHasta ? ("- " + (o.horaHasta)) : ''))])]), _c('div', {
      staticClass: "botones"
    }, [(o.codigoCreador === _vm.codigo) ? [_c('button', {
      staticClass: "button is-small m-2",
      on: {
        "click": function($event) {
          return _vm.redirigir(o.id)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]), (o.estado !== 1) ? _c('button', {
      staticClass: "button is-small m-2 is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]), _c('span', [_vm._v("Eliminar")])]) : _vm._e()] : _vm._e(), _c('button', {
      staticClass: "button is-small m-2",
      on: {
        "click": function($event) {
          return _vm.verDetalle(o.id)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Ver")])])], 2)])
  }), 0)])], 1), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _vm._e(), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', {
    staticClass: "has-text-bold"
  }, [_vm._v("No existe reuniones")])])]) : _vm._e()])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mis reuniones")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-786d9e55","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Reuniones.vue
// module id = 839
// module chunks = 0